import * as React from 'react';
import InputLabel  from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { arrayRange } from "../../utils/Common"

export class FormattedInputProps {
  value: any;
  onChange: any;
  onBlur?: any;
  helpText?: string;
  label?: string;
  name: string;
  error?: string;
  ref?: any;
}

export const MonthInput: React.FunctionComponent<FormattedInputProps> = ({ value, onChange, onBlur, helpText, label, name, error, ref }) => {

  return (<>
      {label?<InputLabel sx={{fontSize: 15, fontWeight: 600}}>{label}</InputLabel>:<></>}
      <Select required
        sx={{ mx: 0, mt: "2px", mb: "14px" }}
        fullWidth
        variant="outlined"
        value={value}
        name={name}
        onChange={onChange}>
        {arrayRange(1, 31, 1).map((n)=><MenuItem key={"m" + n} value={n}>{n}</MenuItem>)}
      </Select>
  </>);
}